import { StyleSheet } from 'react-native';

import { blackTransparent } from 'utils/colors';
import { heightPercentageToDP } from 'utils/responsiveness';

import { CAST_ITEM_SIZE_WEB } from 'components/CustomButtons/RibbonTouchable/styles';
import { TILE_TITLE_HEIGHT } from 'components/Ribbon/components/TileTitle/styles';
import { CAST_STRIPE_MARGIN_TOP } from 'components/Ribbon/styles';

const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        top: 0,
        height: '100%',
        zIndex: 1,
    },
    containerWithBottomMargin: {
        paddingBottom: TILE_TITLE_HEIGHT + 4,
    },
    containerWithTopMargin: {
        paddingTop: TILE_TITLE_HEIGHT,
    },
    arrowButton: {
        flex: 1,
        width: '100%',
        backgroundColor: blackTransparent(0.7),
    },
    bwdButton: {
        left: 0,
        paddingBottom: heightPercentageToDP(18),
        transform: [
            {
                rotate: '180deg',
            },
        ],
    },
    fwdButton: {
        right: 0,
        paddingTop: heightPercentageToDP(20),
    },
    castStripe: {
        padding: 0,
        height: CAST_ITEM_SIZE_WEB * 1.5,
    },
});

export default styles;
